import videojs from 'video.js';

const VolumePanel = videojs.getComponent('VolumePanel');

const isMobile = () => {
  if (/Mobi|Android/i.test(navigator.userAgent)) {
    return true;
  }
  return false;
};

export class CustomVolumePanel extends VolumePanel {
  createEl(tagName?: string | undefined, properties?: any, attributes?: any): Element {
    const el = super.createEl(tagName, properties, attributes);

    if (isMobile()) {
      el.classList.add('mobile');

      setTimeout(() => {
        const volumeBar = el.querySelector('.vjs-volume-vertical') as HTMLElement;

        if (volumeBar) {
          volumeBar.style.display = 'none';
        }
      }, 1000);

      return el;
    }

    el.addEventListener('touchstart', (e) => {
      e.stopPropagation();
      const classList = (e.currentTarget as HTMLElement | null)?.classList;

      if (!classList?.contains('vjs-volume-panel-active')) {
        classList?.add('vjs-volume-panel-active');
      }
    });

    return el;
  }
}
